import React, { Component } from 'react';
import {connect} from 'react-redux';
import {
    Modal, 
    Button, 
    FormGroup, 
    ControlLabel, 
    FormControl,
} from 'react-bootstrap';

class MoreData extends Component {
    constructor(props){
        super(props);
        this.state = {
            startWeek: ''
        };
        this.weeks = [];
    }
    
    componentDidMount(){
        let now = new Date();
        let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        let dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1;
        let weekEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate() 
                - dayOfWeek - 7);
        let week = new Date(2019, 4, 27);

        while (week.getTime() < weekEnd.getTime()){
            this.weeks.push(week.getDate() + '/' + (week.getMonth() + 1) + '/' + week.getFullYear());
            week = new Date(week.getFullYear(), week.getMonth(), week.getDate() + 7);
        }
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        
        this.setState({[name]: value});
    }

    handleUpdate = () => {
        let dt = new Date(parseInt(this.state.startWeek.split('/')[2]), 
            parseInt(this.state.startWeek.split('/')[1]) - 1, 
            parseInt(this.state.startWeek.split('/')[0]));
        dt = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() - 1);
        
        this.props.onUpdate(dt.getDate() + '/' + (dt.getMonth() + 1) + '/' + dt.getFullYear());   
    }

    render(){
        const opt = this.weeks.map((i, k) => {
            const w = ((k + 21) % 52) + 1;
            return <option value={i} key={k}>Wk{w} starting {i}</option>;
        });
        return (
            <Modal show={this.props.showMoreData} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Get More Data</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <FormGroup controlId="formWeekNo">
                            <ControlLabel>From Week</ControlLabel>
                            <FormControl componentClass="select" placeholder="Select Week No."
                                onChange={this.handleChange} name="startWeek" 
                                value={this.state.startWeek}>
                                {opt}
                            </FormControl>
                        </FormGroup>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.handleUpdate}>Add</Button>
                    <Button bsStyle="danger" onClick={this.handleClose}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    const { device } = state;
        
    return { device };
}

export default connect(mapStateToProps)(MoreData); 